var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9312 0.282063L15.0703 6.95326L22.0875 8.02329C22.2692 8.05153 22.4199 8.18491 22.4765 8.36756C22.533 8.55022 22.4858 8.75061 22.3544 8.88482L17.2777 14.0765L18.4763 21.4087C18.5078 21.5978 18.4338 21.7891 18.2854 21.9021C18.137 22.0151 17.94 22.0301 17.7775 21.9407L11.5007 18.4796L5.22391 21.9417C5.06154 22.0314 4.86448 22.0167 4.71597 21.9037C4.56747 21.7908 4.49342 21.5993 4.52511 21.4102L5.72374 14.0765L0.64557 8.88482C0.514231 8.75061 0.466952 8.55022 0.523537 8.36756C0.580123 8.18491 0.730803 8.05153 0.912465 8.02329L7.92969 6.95326L11.0702 0.282063C11.1502 0.109563 11.3174 0 11.5007 0C11.6841 0 11.8513 0.109563 11.9312 0.282063Z",
    fill: "#00B67A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar2);
export default __webpack_public_path__ + "static/media/star2.96a3c026f08a5a71976947455bde22bb.svg";
export { ForwardRef as ReactComponent };